import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import FlutesView from "@/views/FlutesView.vue";
import HeadjointsView from "@/views/HeadjointsView.vue";
import CustomView from "@/views/CustomView.vue";
import WhistlesView from "@/views/WhistlesView.vue";
import ImpressumView from "@/views/ImpressumView.vue";
import DatenschutzView from "@/views/DatenschutzView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/flutes",
    name: "flutes-detail",
    component: FlutesView,
  },
  {
    path: "/headjoints",
    name: "headjoints-detail",
    component: HeadjointsView,
  },
  {
    path: "/custom",
    alias: "/whistles/custom",
    name: "custom",
    component: CustomView,
  },
  {
    path: "/whistles",
    alias: "/whistles/prices",
    name: "whistles-detail",
    component: WhistlesView,
  },
  {
    path: "/impressum",
    name: "impressum",
    component: ImpressumView,
  },
  {
    path: "/datenschutz",
    name: "datenschutz",
    component: DatenschutzView,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash, top: 80 };
    }
    return { top: 0 };
  },
});

export default router;
